import { useMemo } from 'react'
import { CardDimensions } from 'containers/RowContainer/RowSimpleContainer/hooks/useSimpleVisibleCards'

export const usePlayerRecommendationsVisibleCards = (
  clientWidth: number
): number => {
  return useMemo(() => {
    if (!clientWidth) return 0

    if (clientWidth < CardDimensions.MOBILE_L) return 1.71

    if (clientWidth < CardDimensions.TABLET_L) {
      return clientWidth < CardDimensions.TABLET_S ? 2 : 3
    }

    return 4
  }, [clientWidth])
}
